import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { MeetingsPage } from '@/pages/meetings/MeetingsPage';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';

const meetingsSearchSchema = z.object({
	page: z.coerce.number().default(1),
	limit: z.coerce.number().default(10),
	search: z.string().optional(),
	status: z.enum(['all', 'upcoming', 'past']).default('all'),
	scope: z.enum(['mine', 'others', 'all']).optional(),
	userIds: z.string().optional(),
	from: z.string().optional(),
	to: z.string().optional(),
	view: z.enum(['list', 'calendar']).default('list'),
});

export const Route = createFileRoute('/_authenticated/_app/meetings')({
	beforeLoad: ({ context }) =>
		requireAnyPermission({
			context,
			anyOf: ['meetings.read.own', 'meetings.read.all', 'meetings.create'],
			redirectTo: '/dashboard',
		}),
	component: MeetingsPage,
	validateSearch: meetingsSearchSchema,
});
